import { CustomerPermission } from "./CustomerPermission";
import { ShipTo } from "./ShipTo";

export class Distributor {
  constructor() {
    this.CompanyId = "";
    this.Permissions = [];
    this.ShipTos = [];
  }
  BuildDistributor(dist: Distributor):Distributor {
    this.Company = dist.Company;
    this.CompanyId = dist.CompanyId;
    this.Address1 = dist.Address1;
    this.Address2 = dist.Address2;
    this.City = dist.City;
    this.State = dist.State;
    this.ZipCode = dist.ZipCode;
    this.Country = dist.Country;
    this.Email = dist.Email;
    this.Phone = dist.Phone;
    this.CstaccountNumber = dist.CstaccountNumber;
    this.Active = dist.Active;
    this.ERPCustomerNumber = dist.ERPCustomerNumber;
    this.CustType = dist.CustType;
    this.SortIndex = dist.SortIndex;
    this.Permissions = dist.Permissions;
    this.ShipTos = dist.ShipTos;
    return this;
  }
  public Company: string;
  public CompanyId: string;
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public ZipCode: string;
  public Country: string;
  public Email: string;
  public Phone: string;
  public CstaccountNumber: string;
  public Active: string;
  public ERPCustomerNumber: string;
  public CustType: string;
  public SortIndex: number;
  public Permissions: CustomerPermission[];
  public ShipTos: ShipTo[];
}
